<template>
    <div>
        <h1>Latest backups</h1>
        <backup-list
            :backups="backups"
        ></backup-list>
    </div>
</template>

<script>
import BackupList from '@/components/BackupList';
export default {
    name: 'BackupListPage',
    components: {BackupList},
    methods: {
        loadBackups () {
            this.$http.get('/api/backups')
                .then(response => {
                    this.backups = response.data;
                });
        },
        startBackupRefresh () {
            this.stopBackupRefresh();
            this.loadBackups();
            this.backupRefreshTimer = setInterval(this.loadBackups, 5000);
        },
        stopBackupRefresh () {
            if (null === this.backupRefreshTimer) {
                return;
            }

            clearInterval(this.backupRefreshTimer);
            this.backupRefreshTimer = null;
        }
    },
    data () {
        return {
            backupRefreshTimer: null,
            backups: [],
        };
    },
    mounted () {
        this.startBackupRefresh();
    },
    beforeDestroy () {
        this.stopBackupRefresh();
    }
}
</script>
